<template>
    <div class="col-md-8">
        <h3>
            Recalculate prices
        </h3>
        <h5>
            The prices will be saved and replace the current booking prices only after clicking the green 'save new
            prices' button
        </h5>
        <br/>
        <br/>
        <form @submit.prevent="calc">
            <div class="form-group">
                <label class="d-block mb-0 font-weight-bold"> booking ids with comma</label>
                <div class="">
                    <input type="text" class="form-control" v-model="bookings.ids" placeholder="1234, 1235, 1237">
<!--                    <v-select-->
<!--                        :multiple=true-->
<!--                        :taggable=true-->
<!--                        :options="bookingList"-->
<!--                        v-model="bookings"-->
<!--                        label="value"-->
<!--                    >-->
<!--                    </v-select>-->
                </div>
            </div>

            <button class="btn btn-primary"> Preview prices</button>
            <br/>
            <br/>

            <div class="table-responsive">
                <table class="table table-bordered table-striped">
                    <thead>
                    <tr>
                        <th class="border-right text-center">
                            Booking
                        </th>
                        <th class="border-right text-center">
                            Product price
                        </th>
                        <th class="border-right text-center">
                            Service price
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(price,k) in prices">
                        <td class="text-center">
                            B-{{ k }}
                        </td>
                        <td class="text-center">
                            <span v-if="price.product===0"> Not set </span>
                            <span v-if="price.product>0"> {{ price.product }}</span>
                        </td>
                        <td class="text-center">
                            <span v-if="price.service.priceServiceSum===0"> Not set </span>
                            <span v-if="price.service.priceServiceSum>0"> {{ price.service.priceServiceSum }}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </form>
        <button @click="saveNewPrices()" class="btn btn-success"> Save new prices</button>

    </div>
</template>
<script>
import 'vue-select/dist/vue-select.css';

export default {
    name: "RecalculatePrice",
    data() {
        return {
            bookingList: [
                {
                    id: '',
                    value: '',
                },
            ],
            bookings: {ids:[]},
            prices: {},
        }
    },
    methods: {
        fetchData() {
            axios.get(`/booking-list`, {params: {length: 99}})
                .then(({data}) => {
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.bookingList.push({
                            id: value.id,
                            value: `B-${value.id}`,
                        });
                    });
                }).catch();
        },
        calc() {
            axios.post(`/get-recalculated-prices`, this.bookings)
                .then(({data}) => {
                    this.prices = data.data
                }).catch();
        },
        saveNewPrices() {
            axios.post(`/store-recalculated-prices`, this.prices)
                .then(({data}) => {
                    alert('saved');
                    //window.location.reload();
                }).catch();
        },
    },
    created() {
        return this.fetchData();
    },
}
</script>
<style>

.booking-select .vs__dropdown-menu {
    width: 600px !important;
}

.colli-grouped {
    min-width: 90%;
}


.disabled-colli {
    display: none;
}

.update-colli-data {
    margin-left: 10px;
}

</style>
